import Typed from "typed.js"
import Rellax from "rellax"

const Members = () => {
  const typedElements = document.querySelectorAll(".typed")
  typedElements.forEach(function(element) {
    const typed = new Typed(element, {
      stringsElement: ".typed-strings",
      typeSpeed: 40,
      showCursor: false
    })
  })

  const parallaxContainer = document.querySelector(".background-parallax")
  if (parallaxContainer) {
    const parallaxContainerHeight = parallaxContainer.offsetHeight

    const rellax = new Rellax(parallaxContainer, {
      speed: -10,
      center: false,
      round: false,
      vertical: true,
      horizontal: false,
      callback: function(positions) {
        const zoom = 1 + window.pageYOffset / parallaxContainerHeight / 20
        const opacity = 1 - window.pageYOffset / parallaxContainerHeight
        const css =
          "transform:scale3d(" + zoom + ", " + zoom + ", 1); opacity:" + opacity
        parallaxContainer.style.cssText = css
      }
    })
  }
}

export { Members }
